import { DetailedHTMLProps, InputHTMLAttributes } from 'react';

export const ChapterSlideNumberInput = ({ ...props }: DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) => (
    <td data-testid="slideNumber" className="relative px-2 py-0">
        <div className="group relative w-full mb-6">
            <div className="flex justify-between">
                <input type="number" className="w-full bg-transparent outline-hidden py-input-vert text-base text-right" {...props} />
            </div>
            <div className="bg-black group-hover:bg-primary group-focus-within:bg-primary input-border" />
        </div>
    </td>
);
